/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'payments': {
    width: 18,
    height: 15,
    viewBox: '0 0 18 15',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M17.429.571H.57V4H17.43V.571zm-14.858 2V2h2v.571h-2zM12.571 6.571h4.857V8h-4.857zM17.429 10.286H.57V14H17.43v-3.714zM16 12.57h-3.714V12H16v.571zM.571 8.571h2.857v1.143H.571zM4 8.571h8v1.143H4zM4 4.571h8V6H4zM4 6.571h8V8H4zM12.571 8.571h4.857v1.143h-4.857z"/><path pid="1" d="M0 14.571h18V0H0v14.571zm17.429-4.857H12.57V8.571h4.858v1.143zM12 4.571V6H4V4.571h8zm0 2V8H4V6.571h8zm0 2v1.143H4V8.571h8zM17.429 8H12.57V6.571h4.858V8zm0-2H12.57V4.571h4.858V6zM.57.571H17.43V4H.57V.571zm0 4H3.43V6H.57V4.571zm0 2H3.43V8H.57V6.571zm0 2H3.43v1.143H.57V8.571zm0 1.715H17.43V14H.57v-3.714z" _fill="#EEF5F4" fill-rule="nonzero"/><path pid="2" _fill="#EEF5F4" fill-rule="nonzero" d="M12.286 12H16v1h-3.714zM2.571 2h2v1h-2z"/></g>'
  }
})
